<template>
  <div class="kanban-main-menu" style="padding: 5px 10px;">

    <v-btn class="kanban-btn-board" :title="toolbar.allBoards.tooltip" @click="$emit( 'allBoards' )">{{ toolbar.allBoards.name }}</v-btn>

    <div style="display: inline-block;">
      <v-menu offset-y class="boards-menu">
        <template v-slot:activator="{ on }">
          <v-btn class="kanban-btn-board" @click="" v-on="on">{{ toolbar.selectBoard.name }}</v-btn>
        </template>
        <v-card color="white" style="max-height: 400px;">
          <v-list v-for="( group, index ) in boardsGroups" :key="index" subheader>
            <v-subheader style="color: #907fa5;">{{ group.name }}</v-subheader>
            <v-list-tile
                    v-for="( board, index ) in group.boards"
                    :key="index"
                    @click="$emit( 'selectBoard', board )"
            >
              <v-list-tile-title>{{ board.name }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="group.boards.length === 0">
              <v-list-tile-content>
                <v-list-tile-title class="kanban-list-empty">{{ toolbar.selectBoard.default }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="index + 1 < boardsGroups.length"></v-divider>
          </v-list>
        </v-card>
      </v-menu>
    </div>

    <v-btn v-if="isBoardMode()" class="kanban-btn-board pa-0" @click="toggleFavorite()">
      <v-icon class="board-favorite mx-0">{{ getIcon() }}</v-icon>
    </v-btn>

    <div v-if="isBoardMode()" style="display: inline-block;">
      <v-menu offset-y class="boards-menu">
        <template v-slot:activator="{ on }">
          <v-btn class="kanban-btn-board" @click="" v-on="on">
            <v-icon class="mx-0">{{ toolbar.addCard.icon }}</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="( publication, index ) in publications"
            :key="index"
            @click="$emit( 'addCard', publication )"
          >
            <v-list-tile-title>{{ publication.name }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="publications.length === 0">
            <v-list-tile-content>
              <v-list-tile-title class="kanban-list-empty">{{ toolbar.addCard.default }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>

    <v-btn class="kanban-btn-board" @click="$emit( 'addBoard' )">{{ toolbar.addBoard.name }}</v-btn>

    <v-btn v-if="isBoardMode() && isEditMode()" class="kanban-btn-board" @click="$emit( 'addSection' )">{{ toolbar.addSection.name }}</v-btn>

    <v-btn v-if="isBoardMode() && isEditMode()" class="kanban-btn-board pa-0" title="Редактирование доски" @click="$emit( 'editBoard', board )">
      <v-icon class="mx-0">{{ toolbar.editBoard.icon }}</v-icon>
    </v-btn>

    <v-btn v-if="isBoardMode() && isEditMode()" class="kanban-btn-board pa-0" title="Удаление доски" @click="$emit( 'deleteBoard', board )">
      <v-icon class="mx-0">{{ toolbar.deleteBoard.icon }}</v-icon>
    </v-btn>

    <v-btn v-if="false && isBoardMode()" class="kanban-btn-board pa-0" style="background-color: #915151 !important;" @click="">
      <v-icon class="mx-0">{{ toolbar.warnings.icon }}</v-icon>
    </v-btn>

    <div v-if="isBoardMode()" class="kanban-board-name" title="Название доски" @click="">{{ board.name }}</div>

    <v-spacer></v-spacer>

    <v-btn icon class="kanban-btn-board" style="background: none !important;" @click="">
      <v-icon class="">settings</v-icon>
    </v-btn>

  </div>
</template>

<style>

  .kanban-main-menu .kanban-btn-board .board-favorite {
    color: #db4 !important;
  }

  .kanban-main-menu .kanban-btn-board:hover .board-favorite {
    color: #eee !important;
  }

</style>

<script>

  /**
   *
   *
   * @type {{}}
   */
  const TOOLBAR = {

    allBoards: {
      name: 'Все доски',
      icon: null,
      tooltip: 'Переход в режим управления всеми досками'
    },

    selectBoard: {
      name: 'Выбрать доску...',
      default: 'Нет досок в данной категории',
      icon: null,
      tooltip: null
    },

    addBoard: {
      name: '+ Добавить доску',
      icon: null,
      tooltip: null
    },

    addSection: {
      name: '+ Добавить колонку',
      icon: null,
      tooltip: null
    },

    addCard: {
      name: '+', // '+ Создать задачу',
      default: 'Нет доступных для создания задач',
      icon: 'mdi-play',
      tooltip: null
    },

    toggleFavorite: {
      name: 'Избранная доска',
      icon: 'star_border',
      tooltip: ''
    },

    editBoard: {
      name: 'Редактирование доски',
      icon: 'edit',
      tooltip: 'Редактирование доски'
    },

    deleteBoard: {
      name: 'Удаление доски',
      icon: 'delete',
      tooltip: 'Удаление доски'
    },

    warnings: {
      name: 'Предупреждения',
      icon: 'warning',
      tooltip: 'Список предупреждений'
    }
  }



  /**
   *
   *
   */
  export default {

    name: 'KanbanToolbar',

    /**
     *
     *
     */
    props: {

      // Режим панели инструментов.
      mode: {
        type: String,
        required: true,
        validator: function ( value ) {
          return [ 'all-boards', 'one-board' ].indexOf( value ) !== -1
        }
      },

      // Уровень доступа.
      access: {
        type: String,
        required: true,
        validator: function ( value ) {
          return [ 'view', 'edit' ].indexOf( value ) !== -1
        }
      },

      // Список досок.
      boards: {
        type: Array,
        required: false,
        default: []
      },

      //
      boardsGroups: {
        type: Array,
        required: false,
        default: []
      },

      // Список публикаций.
      publications: {
        type: Array,
        required: false,
        default: []
      },

      // Доска.
      board: {
        type: Object,
        required: false,
        default: { name: '' }
      },
    },

    /**
     *
     *
     */
    data() {

      return {

        // Описание панели инструментов.
        toolbar: TOOLBAR,

        // Статус избранного.
        isFavorite: false
      }
    },

    /**
     *
     *
     */
    watch: {

      /**
       * Статус избранного.
       *
       */
      board: {

        handler( board ) {

          this.isFavorite = board ? board.favorite : false
        },

        // Необходимо для инициализации значения по умолчанию
        immediate: true,

        // Необходимо для отслеживания всех свойств объекта на всю глубину
        deep: true
      }
    },

    /**
     *
     *
     */
    computed: {

    },

    /**
     *
     *
     */
    methods: {

      /**
       * Инициализация компонента.
       *
       */
      init() {


      },

      /**
       * Текущий режим - по умолчанию?
       *
       */
      isDefaltMode() {
        return this.mode === 'all-boards'
      },

      /**
       * Текущий режим - режим работы с доской?
       *
       */
      isBoardMode() {
        return this.mode === 'one-board'
      },

      /**
       * Проверка разрешения редактирования доски.
       *
       */
      isEditMode() {
        return this.access === 'edit'
      },

      /**
       * Переключение статуса избранного в противоположное состояние.
       *
       */
      toggleFavorite() {

        let board = Object.assign( {}, this.board )

        this.isFavorite = !this.isFavorite
        board.favorite = this.isFavorite
        this.$emit( 'favorite', board, this.isFavorite )
      },

      /**
       * Получение иконки.
       *
       * @returns {string}
       */
      getIcon() {
        return this.isFavorite ? 'star' : 'star_border'
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/apps/bpm/kanban/components/KanbanToolbar.vue